import { useState, useEffect } from "react";

const LOGO_URL = "https://assets.wordaliveglobal.org/branding/wagc_logo_small.png";

export function SplashScreen({ onComplete }) {
  const [stage, setStage] = useState("cross"); // cross, logo, fade

  useEffect(() => {
    // Stage 1: Cross animation (500ms)
    const crossTimer = setTimeout(() => {
      setStage("logo");
    }, 500);

    // Stage 2: Logo appears (800ms)
    const logoTimer = setTimeout(() => {
      setStage("fade");
    }, 1300);

    // Stage 3: Complete (300ms fade)
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 1600);

    return () => {
      clearTimeout(crossTimer);
      clearTimeout(logoTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  const handleSkip = () => {
    setStage("fade");
    setTimeout(onComplete, 100);
  };

  if (stage === "fade") {
    return (
      <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-[#1B2A4A] to-[#2A3A5A] animate-fadeOut pointer-events-none">
        <style>{`
          @keyframes fadeOut {
            from { opacity: 1; }
            to { opacity: 0; }
          }
          .animate-fadeOut {
            animation: fadeOut 0.3s ease-out forwards;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-[#1B2A4A] to-[#2A3A5A] flex items-center justify-center">
      {/* Skip Button */}
      <button
        onClick={handleSkip}
        className="absolute top-8 right-8 text-[#C8A951] text-sm hover:text-[#D4B961] transition-colors z-10"
      >
        Skip →
      </button>

      <div className="relative w-full max-w-md px-8">
        {/* Animated Cross Lines */}
        <div className="absolute inset-0 flex items-center justify-center">
          {/* Vertical line */}
          <div
            className={`absolute w-1 bg-[#C8A951] transition-all duration-500 ${
              stage === "cross" ? "h-0" : "h-32"
            }`}
            style={{
              boxShadow: "0 0 20px rgba(200, 169, 81, 0.5)",
            }}
          />
          {/* Horizontal line */}
          <div
            className={`absolute h-1 bg-[#C8A951] transition-all duration-500 ${
              stage === "cross" ? "w-0" : "w-32"
            }`}
            style={{
              boxShadow: "0 0 20px rgba(200, 169, 81, 0.5)",
            }}
          />
        </div>

        {/* Logo and Text */}
        <div
          className={`relative flex flex-col items-center gap-4 transition-all duration-500 ${
            stage === "logo" ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }`}
        >
          {/* Logo */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-[#C8A951]/30">
            <img
              src={LOGO_URL}
              alt="Word Alive Global Center"
              className="w-32 h-32 object-contain"
              style={{
                filter: "drop-shadow(0 0 15px rgba(200, 169, 81, 0.3))",
              }}
            />
          </div>

          {/* Text */}
          <div className="text-center">
            <h1 className="text-white font-serif font-bold text-2xl mb-1">
              Word Alive Global Center
            </h1>
            <p className="text-[#C8A951] text-sm tracking-wide">
              A 5-Fold Ministry
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(200, 169, 81, 0.5); }
          50% { box-shadow: 0 0 30px rgba(200, 169, 81, 0.8); }
        }
      `}</style>
    </div>
  );
}
